module.exports = __webpack_public_path__ + "img/amazon.10406372.svg";